import * as React from "react";
import { styled } from "../../ui/theme";
import SmallBarChart from "./SmallBarChart";
import useComponentSize from "../../hook/useComponentSize";
import { useStore } from "../../App";
import { Select, Icon, Box } from "@chakra-ui/core";
import { observer } from "mobx-react";
import DateModal from "./DateModal";
var disposer;

export default observer(function Timeline() {
  const ref = React.useRef<HTMLDivElement>(null);
  const [playing, _playing] = React.useState(false);
  const [pickDate, _pickDate] = React.useState(false);
  const size = useComponentSize(ref);
  const store = useStore();

  const doPlay = () => {
    if (store.activeIndex < store.dayCount - 1) {
      store.activeIndex = store.activeIndex + 1;
    } else {
      _playing(false);
    }
  };

  React.useEffect(() => {
    if (playing) {
      store.playing = true;
      store.activeIndex = 0;
      disposer = setInterval(doPlay, 1000);
    } else {
      store.playing = false;
      if (disposer) {
        clearInterval(disposer);
        disposer = undefined;
      }
    }

    return () => {
      clearInterval(disposer);
    };
  }, [playing]);

  return (
    <Container>
      <Play>
        <button onClick={() => _playing(p => !p)}>
          {/*
          //@ts-ignore */}
          <Icon name={playing ? "pause" : "play"} color="gray.600" /> {playing ? "pause" : "play"} &nbsp;&nbsp;&nbsp;
        </button>
        <button onClick={() => _pickDate(true)}>
          <Icon name="calendar" color="gray.600" />
          {store.days[store.activeIndex].label}
        </button>
      </Play>
      <Graph ref={ref}>
        <SmallBarChart
          width={size.width > 100 ? size.width : 1}
          height={size.height > 30 ? size.height - 32 : 1}
          active={store.activeIndex}
          data={store.days.map(day => ({
            id: day.index,
            name: day.label,
            total: day.total,
            delta: day.delta
          }))}
          onClick={d => {
            if (store.activeIndex === d) {
              store.activeIndex = store.dayCount - 1;
            } else {
              store.activeIndex = d;
            }
          }}
        />
      </Graph>
      <DateModal isOpen={pickDate} onClose={() => _pickDate(false)} />
    </Container>
  );
});

const Container = styled.div`
  flex-grow: 1;
  display: flex;
  overflow: hidden;
  max-width: 100%;
`;

const Play = styled.div`
  flex: 0 0 88px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  border-right: 1px solid ${props => props.theme.colors.gray["600"]};

  button {
    outline: 0;
    flex: 0 0 50%;
    padding: 0 8px;
    font-size: 12px;
    &:first-of-type {
      border-bottom: 1px solid ${props => props.theme.colors.gray["600"]};
    }
    font-weight: bold;
    color: ${props => props.theme.colors.gray["100"]};
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
`;

const Graph = styled.div`
  flex: 1 1 auto;
  padding: 16px 0;
  overflow: hidden;
`;

const Sel = styled.div`
  flex: 0 0 100px;
`;

// <PlayButton />
// <Select
//   variant="filled"
//   backgroundColor="gray.400"
//   placeholder="Dag"
//   size="sm"
//   value={store.activeIndex}
//   onChange={e => {
//     store.activeIndex = parseInt(e.currentTarget.value, 10);
//   }}
// >
//   {store.days.map(day => (
//     <option key={day.index} value={day.index}>
//       {day.label}
//     </option>
//   ))}
// </Select>
